import { PartialApplicationState } from './Dashboard.types';
import MainContentPending from '../../pageStructure/mainContentPending/MainContentPending';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Button } from '@iwoca/orion';
import { useGetSpendingLimits } from './hooks/useGetSpendingLimits';

export const PartialView = ({
    application
}: {
    application?: PartialApplicationState;
}) => {
    const { activeSpendingLimit, loadingSpendingLimits } =
        useGetSpendingLimits();

    const redirect_url = application?.payLink.redirect_url;
    const available_spending_limit = activeSpendingLimit?.available_amount || 0;

    if (loadingSpendingLimits) return <MainContentPending />;

    return (
        <div className="px-l py-m">
            <h2 className="m-0 my-xl text-2xl font-bold max-[624px]:text-xl">
                You're <span className="text-success-drk">approved</span> for a{' '}
                <FormattedCurrency value={available_spending_limit} /> spending
                limit.
            </h2>
            <p className="m-0 mb-xl text-xl font-med max-[624px]:text-l">
                To use Pay Later for your order you’ll need to reduce the total
                amount to <FormattedCurrency value={available_spending_limit} />{' '}
                or less.{' '}
            </p>
            {redirect_url && (
                <Button
                    href={redirect_url}
                    variant="primary"
                    size="large"
                    className="mb-xl max-[624px]:w-full"
                >
                    Go back to your order
                </Button>
            )}
            <p className="m-0 text-m font-reg max-[624px]:text-s">
                If you’d like to speak to us about the decision or you have any
                questions, give us a ring on{' '}
                <a
                    className="font-med text-primary-40"
                    href="tel:0203 778 0549"
                >
                    0203 778 0549
                </a>
            </p>
        </div>
    );
};
